const Helpers = {
	t: function(key) {
		return key ? window.MC_Webnotes_Data.objectL10n[key].replace(/&amp;/g, '&').replace(/&quot;/g, '"').replace(/&#039;/g, "'") : window.MC_Webnotes_Data.objectL10n;
	},
	encodeURL: function(str) {
		encodeURIComponent(str).replace(/[!'()]/g, escape).replace(/\*/g, "%2A")
	},
	parseData: function(str) {
		let data;
		try {
			data = JSON.parse(str);
		} catch(e) {
			data = str;
		}
		return data;
	},
	serialize: function(obj, prefix) {
		var str = [], p;
		for(p in obj) {
			if (obj.hasOwnProperty(p)) {
				var k = prefix ? prefix + "[" + p + "]" : p, v = obj[p];
				str.push((v !== null && typeof v === "object") ?
					Helpers.serialize(v, k) :
					encodeURIComponent(k) + "=" + encodeURIComponent(v));
			}
		}
		return str.join("&");
	},
	post: function (data) {
		return new Promise(function (resolve, reject) {
			// Do some Async stuff
			// call resolve if it succeeded
			// reject if it failed
			var xhr = new XMLHttpRequest();
			xhr.open('POST', '/wp-admin/admin-ajax.php');
			xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
			xhr.onload = function() {
				if (xhr.status === 200) {
					resolve(Helpers.parseData(xhr.responseText));
				} else {
					reject({
						status: this.status,
						statusText: xhr.statusText
					});
				}
			};
			xhr.onerror = function () {
				reject({
					status: this.status,
					statusText: xhr.statusText
				});
			};
			xhr.send(Helpers.serialize(data));
		});
	},
};

export default Helpers;


// WEBPACK FOOTER //
// ./src/js/helpers.js